
/**
 * storage 存储的关键key
 */
export const STORAGE = {
  LANGUAGE_TEXT: 'LANGUAGE_TEXT',
  TASK_FILTERS: 'TASK_FILTERS',
  TRANS_CALENDAR_TASK_FILTERS: 'transCalendarTaskFilters'
}
/**
 * 任务相关的常量
 */
export const TASK_DETAIL = {
  DAY_TYPE_ALL: 1, // 全天
  DAY_TYPE_UN: 2, // 非全天
  TIME_TYPE_TASK: 1, // 到期时间：任务
  TIME_TYPE_CALENDAR: 2, // 起止时间：日程
  VALID_DELETED: 0, // 已删除
  VALID_UN: 1, // 未删除
  STATE_FINISHED: 1, // 已完成
  STATE_UN: 0 // 未完成
}

/**
 * 权限位常量
 */
export const PERMISSIONS = {
  MAT_MATTER_TIMELOG_ADD: 'MAT:matter.timeLog:add'
}

/**
 * 任务状态
 */
export const TASK_STATUS = {
  UN_FINISH: {
    value: 1,
    label: '未完成'
  },
  FINISHED: {
    value: 2,
    label: '已完成'
  },
  DELETED: {
    value: 3,
    label: '已删除'
  }
}
